import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { useContext, useEffect, useMemo, useState } from 'react';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelEspecialista = (sexoPaciente, especialidadeEscolha, patient, data_atendimento, nascimento) => {
  const { setUser, user } = useContext(AccountContext);
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notificacao, setNotificacao] = useState([]);
  const [atendimentoRestrito, setAtendimentoRestrito] = useState(false);
  let idade = 0;
  const regraid = [55, 29];
  const contrato_id = user.titular ? user.id_contrato : user.id_contrato_dependent.paciente_contrato_id;

  async function listarEspecialidades() {
    try {
      setLoading(true);
      const url = ENDPOINT + `/schedule/list-specialities/${sexoPaciente}/${contrato_id}`;
      const response = await api(url, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const postsData = await response.json();
      setEspecialidades(postsData?.specialityList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function listarAtendimentos() {
    try {
      setLoading(true);
      const url =
        especialidadeEscolha === '54' || especialidadeEscolha === 54
          ? `${ENDPOINT}/clients/sessaoPsicologo`
          : `${ENDPOINT}/schedule/listar-atendimentos`;
      const postsData = await api(`${url}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: data_atendimento, cpf: patient, especialidade: especialidadeEscolha }),
      });
      setLoading(false);
      const response = await postsData.json();
      return response;
    } catch (error) {
      setLoading(false);
    }
  }

  function calcularIdade(nascimento) {
    const birthDate = new Date(nascimento);
    const today = new Date();
    const age =
      today.getFullYear() -
      birthDate.getFullYear() -
      (today.getMonth() < birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate()) ? 1 : 0);
    return age;
  }
  idade = calcularIdade(nascimento);

  async function notificacaoEspecialsita() {
    setLoading(true);
    try {
      await api(`${ENDPOINT}/schedule/listPatientNotifications/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: patient }),
      })
        .then(async (res) => {
          return res.json();
        })
        .then(async (dados) => {
          setLoading(false);
          setNotificacao(dados);
        });
    } catch (error) {
      setLoading(false);
    }
  }

  async function fetchAgendamento() {
    try {
      setLoading(true);
      await api(`${ENDPOINT}/clients/verificaFaltasAtendimento/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: patient, plano_id: user?.id_plano }),
      })
        .then(async (res) => {
          return res.json();
        })
        .then(async (resposta) => {
          setLoading(false);
          setAtendimentoRestrito(resposta);
        });
    } catch (error) {
      setLoading(false);
    }
  }


  useEffect(() => {
    notificacaoEspecialsita();
    listarEspecialidades();
    if (regraid.includes(user?.id_plano)) {
      fetchAgendamento(contrato_id);
    }
  }, []);

  return {
    especialidades,
    loading,
    listarAtendimentos,
    idade,
    notificacaoEspecialsita,
    notificacao,
    atendimentoRestrito,
  };
};

export default useModelEspecialista;
